module.exports = __webpack_public_path__ + "assets/chevronLeft-5deeb4.svg";